import React from "react";
import { Link } from "react-router-dom";
import { PlayCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Header } from "@/components/Header";
import { ShareButton } from "@/components/ShareButton";
import { RoomPoster } from "@/components/RoomPoster";

const SITE_URL = "https://neox.lk";

export default function Invite() {
  const { t, fontClass } = useLang();

  return (
    <div className="min-h-screen" style={{ background: "var(--bg)" }}>
      <Header />
      <section className="max-w-2xl mx-auto px-5 sm:px-6 pt-12 pb-28 text-center" data-testid="invite-page">
        <div
          className="rounded-[2rem] px-6 py-12 sm:py-16"
          style={{ background: "linear-gradient(135deg, #1C140E 0%, #3B2A16 55%, #92400E 150%)", border: "2px solid var(--border)" }}
        >
          <div className="text-6xl sm:text-7xl leading-none">🪔</div>
          <h1 className={`${fontClass()} text-4xl sm:text-5xl font-extrabold mt-5`} style={{ color: "#fff", lineHeight: 1.25 }}>
            ස්වාරාන්ජලිය
          </h1>
          <p className="font-en text-sm sm:text-base font-bold tracking-[0.3em] mt-2" style={{ color: "#F5C97A" }}>
            NEOX MUSIC ROOM
          </p>
          <p className={`${fontClass()} text-lg mt-5`} style={{ color: "rgba(255,255,255,0.85)" }} data-testid="invite-tagline">
            {t("invite_page_tag")}
          </p>
          <p className="font-ui text-sm mt-2" style={{ color: "rgba(255,255,255,0.6)" }}>
            {t("invite_page_sub")}
          </p>

          <Link
            to="/rooms/sindu-kamare"
            data-testid="invite-listen-free"
            className="inline-flex items-center justify-center gap-2 mt-9 h-16 px-10 rounded-full font-ui font-extrabold text-lg transition-transform hover:scale-[1.03] active:scale-95 sk-glow"
            style={{ background: "var(--player-accent)", color: "#1C140E" }}
          >
            <PlayCircle size={26} /> {t("invite_listen_free")}
          </Link>
        </div>

        <div className="mt-8 rounded-3xl p-5 sm:p-6" style={{ background: "var(--card)", border: "2px solid var(--border)" }}>
          <p className={`${fontClass()} text-base sm:text-lg font-bold`} style={{ color: "var(--text)" }}>
            {t("invite_send")} 💛
          </p>
          <div className="mt-3 flex justify-center">
            <ShareButton testid="invite-share" text={t("invite_msg")} url={SITE_URL} />
          </div>
          <div className="mt-3 max-w-xs mx-auto">
            <RoomPoster />
          </div>
        </div>
      </section>
    </div>
  );
}
